import { render, staticRenderFns } from "./StatsCardV3.vue?vue&type=template&id=6ebe1f54&"
import script from "./StatsCardV3.vue?vue&type=script&lang=js&"
export * from "./StatsCardV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports